import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { store } from './store';
import { router } from './router';
import {
  listenPushNavigation,
  trackPushOpenedFromUrl,
} from './pushNavigation';
import {
  watchAppInstalled,
  watchLocationPermission,
} from './browserAnalytics';
import { initDeviceId } from '@/shared/auth/deviceId';
import { initPush, watchPushSubscription } from '@/shared/push';
import {
  initAnalytics,
  setAnalyticsUser,
  trackRouterScreens,
} from '@/shared/analytics';
import { readCachedUser } from '@/features/auth';
import { api } from '@/shared/api';
import { analyticsContextFrom } from './store/analyticsMiddleware';
import { ErrorBoundary, OfflineScreen, Toast, PushPrompt } from '@/shared/ui';
import '@/shared/styles/global.less';

// Автоматически активируем новый SW и перезагружаем страницу.
// Только когда контроллер уже есть: без этого первая установка воркера
// перезагружала бы страницу посреди обмена кода ЕСИА
if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}
initAnalytics(analyticsContextFrom(store.getState()));
void store.dispatch(
  api.endpoints.getSettings.initiate(
    { regionFiasId: store.getState().region.regionFias ?? undefined },
    { subscribe: false }
  )
);

// Перезагрузка на внутреннем экране минует проверку сессии в RootRedirect:
// User ID берём из кэша профиля, а без него — из свежего профиля
if (store.getState().login.isLoggedIn) {
  const cachedAnalyticsId = readCachedUser()?.analyticsId;

  if (cachedAnalyticsId) {
    setAnalyticsUser(cachedAnalyticsId);
  } else {
    void store.dispatch(
      api.endpoints.getCurrentUser.initiate(undefined, { subscribe: false })
    );
  }
}

trackRouterScreens(router);
trackPushOpenedFromUrl();
void watchLocationPermission();
watchAppInstalled();

initDeviceId()
  .catch((err) => console.error('[deviceId]', err))
  .then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <ErrorBoundary>
          <Provider store={store}>
            <RouterProvider router={router} />
            <OfflineScreen />
            <Toast />
            <PushPrompt />
          </Provider>
        </ErrorBoundary>
      </React.StrictMode>
    );

    requestAnimationFrame(() => {
      window.hideSplash?.();
    });

    listenPushNavigation();
    initPush(store.dispatch);
    watchPushSubscription(store.dispatch);
  });
